"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../store/redux/selectors");
const account_1 = require("../../store/redux/account");
const react_1 = require("react");
const ErrorMessage = ({ errorComponent, neverDisappear = false }) => {
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'errors' });
    const loginError = (0, react_redux_1.useSelector)(selectors_1.getAccountErrorStatus);
    const dispatch = (0, react_redux_1.useDispatch)();
    const delay = 10000;
    (0, react_1.useEffect)(() => {
        if (loginError && !neverDisappear) {
            setTimeout(() => {
                dispatch((0, account_1.setAccountError)(null));
            }, delay);
        }
    }, [loginError, delay]);
    return (loginError ?
        errorComponent(t(loginError))
        : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
};
exports.default = ErrorMessage;
